import axios from 'axios';
import color from 'css-color-function';
import config from '@/app.config';

const themeColors = config.themeColors;
const textColors = config.textColors;

type ColorsType = {
  [key: string]: string
}

// ************** 方式一 **************
/**
 * @description: 方式一：设置主题颜色
 * @param {ColorsType} colors 主题颜色集
 */
export const setThemeColor = (colors: ColorsType = themeColors) => {
  const el = document.documentElement;
  for (const key in colors) {
    if (Object.prototype.hasOwnProperty.call(colors, key)) {
      el.style.setProperty(`--el-color-${key}`, colors[key]);

      for (let i = 1; i <= 9; i++) {
        el.style.setProperty(`--el-color-${key}-light-${i}`, color.convert(`color(${colors[key]} tint(${(i / 10) * 100}%))`));
        el.style.setProperty(`--el-color-${key}-dark-${i}`, color.convert(`color(${colors[key]} shade(${(i / 10) * 100}%))`));
      }
    }
  }
};

/**
 * @description: 方式一：设置字体颜色
 * @param {ColorsType} colors 字体颜色集
 */
export const setTextColor = (colors: ColorsType = textColors) => {
  const el = document.documentElement;
  for (const key in colors) {
    if (Object.prototype.hasOwnProperty.call(colors, key)) {
      el.style.setProperty(`--el-text-color-${key}`, colors[key]);
    }
  }
};

// ************** 方式二 **************
/**
 * @description: 通过CDN获取ElementPlus样式
 */
const getElDefaultStyle = () => axios.get('https://s1.longfor.com/public/css/element-plus/2.2.8/index.css');

/**
 * @description: 获取格式化之后的主题色
 * @param {ColorsType} colors 主题颜色集
 */
export const formateThemeColors = (colors: ColorsType = themeColors): ColorsType => {
  const newColors: ColorsType = {};
  for (const key in colors) {
    if (Object.prototype.hasOwnProperty.call(colors, key)) {
      newColors[`--el-color-${key}`] = colors[key];
      for (let i = 1; i <= 9; i++) {
        newColors[`--el-color-${key}-light-${i}`] = color.convert(`color(${colors[key]} tint(${(i / 10) * 100}%))`);
        newColors[`--el-color-${key}-dark-${i}`] = color.convert(`color(${colors[key]} shade(${(i / 10) * 100}%))`);
      }
    }
  }
  return newColors;
};

/**
 * @description: 获取格式化之后的字体颜色
 * @param {ColorsType} colors 字体颜色集
 */
export const formateTextColors = (colors: ColorsType = textColors): ColorsType => {
  const newColors: ColorsType = {};
  for (const key in colors) {
    if (Object.prototype.hasOwnProperty.call(colors, key)) {
      newColors[`--el-text-color-${key}`] = colors[key];
    }
  }
  return newColors;
};

/**
 * @description: 方式2：写入格式化之后的样式
 * @return {*}
 */
export const writeNewStyle = async (
  colors: ColorsType = {
    ...formateThemeColors(),
    ...formateTextColors(),
  }
) => {
  let { data: originalStyle } = await getElDefaultStyle();
  Object.keys(colors).forEach((key) => {
    originalStyle = originalStyle.replace(new RegExp(`${key}:.*?;`, 'g'), `${key}:${colors[key]};`);
  });

  const styles = document.getElementsByTagName('style');
  const hasElCss = [...styles].find((item) => item.id === 'ElementStyles');
  if (hasElCss) {
    // 切换主题
    hasElCss.innerText = originalStyle;
  } else {
    // 第一次进入初始化加载element样式
    const style = document.createElement('style');
    style.type = 'text/css';
    style.id = 'ElementStyles';
    style.innerText = originalStyle;
    document.head.insertBefore(style, document.getElementsByTagName('style')[0]);
  }
};
